import React from "react"
import dayjs, { Dayjs } from "utils/dayjs"

import MonthlyClosings from "models/MonthlyClosings"
import FinanceService from "services/FinanceService"

export default function useMonthlyClosings(onFail?: () => void) {
    const [monthlyClosings, setMonthlyClosings] = React.useState<MonthlyClosings | null>(null)
    const [prevPeriod, setPrevPeriod] = React.useState<Dayjs | null>(null)
    const [newPeriod, setNewPeriod] = React.useState<Dayjs | null>(null)
    const [isLoading, setIsLoading] = React.useState(true)

    const fetchMonthlyClosings = React.useCallback(async () => {
        try {
            const fetchedMonthlyClosings = await FinanceService.getMonthlyClosings()
            if (fetchedMonthlyClosings.items.length > 0) {
                setPrevPeriod(fetchedMonthlyClosings.items[0].period)
                setNewPeriod(dayjs(fetchedMonthlyClosings.items[0].period).add(1, "month"))
            } else {
                setPrevPeriod(null)
                setNewPeriod(dayjs(null))
            }
            setMonthlyClosings(fetchedMonthlyClosings)
            setIsLoading(false)
            return fetchedMonthlyClosings
        } catch (e) {
            setPrevPeriod(null)
            setNewPeriod(dayjs(null))
            if (typeof onFail === "function") {
                onFail()
            }
            return null
        }
    }, [onFail])

    React.useEffect(() => {
        fetchMonthlyClosings()
    }, [fetchMonthlyClosings])

    return {
        refetchMonthlyClosings: fetchMonthlyClosings,
        monthlyClosings: monthlyClosings?.items,
        monthlyClosingCreateLink: monthlyClosings?.createLink,
        forecastMonthlyClosingLink : monthlyClosings?.forecastReportLink,
        isLoadingMonthlyClosings: isLoading,
        prevPeriod,
        newPeriod
    }
}
